import type { AnswerValue } from '@/types';

/**
 * Whether a stored answer counts as "given". Mirrors the required-field
 * emptiness check in the page validator so progress and validation agree.
 * Note: the number `0` (e.g. an NPS score of 0) is a real answer, not empty.
 */
export function isAnswered(value: AnswerValue | undefined): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim() !== '';
  if (Array.isArray(value)) return value.length > 0;
  if (typeof value === 'object') return Object.keys(value).length > 0;
  // number (including 0) and any other primitive => answered
  return true;
}
